import { Bell, Home, Menu, UserRound } from 'lucide-react'
import { Badge, Box, IconButton } from '@mui/material'
import { MiscLogo } from './MiscLogo'

export function TopBar() {
  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
        backgroundColor: '#ffffff',
        px: { xs: 2, lg: 4 },
        py: 1.5,
        boxShadow: '0 1px 2px rgba(15, 23, 42, 0.05)',
      }}
    >
      <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
        <MiscLogo />
      </Box>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }} />
      <Box
        component="nav"
        aria-label="Top navigation"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.25, color: '#475569' }}
      >
        <IconButton type="button" aria-label="Home" sx={{ borderRadius: 2, p: 1.25 }}>
          <Home size={20} />
        </IconButton>
        <IconButton type="button" aria-label="Notifications" sx={{ borderRadius: 2, p: 1.25, position: 'relative' }}>
          <Badge
            badgeContent={10}
            color="error"
            sx={{
              '& .MuiBadge-badge': {
                fontSize: 10,
                fontWeight: 600,
                minWidth: 16,
                height: 16,
              },
            }}
          >
            <Bell size={20} />
          </Badge>
        </IconButton>
        <IconButton type="button" aria-label="Menu" sx={{ borderRadius: 2, p: 1.25 }}>
          <Menu size={20} />
        </IconButton>
        <IconButton type="button" aria-label="Profile" sx={{ borderRadius: 2, p: 1.25 }}>
          <UserRound size={20} />
        </IconButton>
      </Box>
    </Box>
  )
}
